/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AdditionalChargeState {
  Proposed = "proposed",
  Approved = "approved",
  Paid = "paid",
  Waived = "waived",
}

export function instanceOfAdditionalChargeState(value: any): boolean {
  for (const key in AdditionalChargeState) {
    if (Object.prototype.hasOwnProperty.call(AdditionalChargeState, key)) {
      if (
        AdditionalChargeState[key as keyof typeof AdditionalChargeState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AdditionalChargeStateFromJSON(
  json: any,
): AdditionalChargeState {
  return AdditionalChargeStateFromJSONTyped(json, false);
}

export function AdditionalChargeStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdditionalChargeState {
  return json as AdditionalChargeState;
}

export function AdditionalChargeStateToJSON(
  value?: AdditionalChargeState | null,
): any {
  return value as any;
}

export function AdditionalChargeStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AdditionalChargeState {
  return value as AdditionalChargeState;
}
